export default __webpack_public_path__ + "static/media/boss_is_out.ce5cb312.mp3";